<template>
  <div @click.stop="handleClick"
       @dragleave.prevent="dragOver = false"
       @dragover.prevent="dragOver = true"
       @drop.prevent="onDrop"
  >
    <input
      :accept="accept"
      :multiple="multiple"
      :picurl="picurl"
      @change="handleChange"
      class="input-style"
      ref="input"
      type="file">
    <slot name="tip"></slot>
  </div>
</template>

<script>
import OssUpload from '../../utils/upload'
import {isOnLine} from '../../config/constantconfig'

const uuidv1 = require('uuid/v1')

export default {
  name: 'UpLoadImage',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    canclick: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String
    },
    picurl: {
      type: String,
      default: 'test/'
    },
    candrag: {
      type: Boolean,
      default: false
    },
    hasPathProName: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dragOver: false,
    }
  },
  methods: {
    handleClick () {
      if (!this.canclick) {
        return this.$Message.info('请切换成编辑状态上传')
      }
      this.$refs.input.click()
    },
    handleChange (e) {
      const files = e.target.files
      if (!files) {
        return
      }
      this.uploadFiles(files)
      this.$refs.input.value = null
    },
    uploadFiles (files) {
      let postFiles = Array.prototype.slice.call(files)
      if (!this.multiple) postFiles = postFiles.slice(0, 1)

      if (postFiles.length === 0) return
      let resultarray = []
      let that = this
      this.$emit('uploadstart', {
        finshnum: 0,
        totalnum: postFiles.length
      })
      postFiles.forEach(file => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          var img = new Image()
          img.src = reader.result
          let width = 0
          let height = 0
          if (img.complete) {
            width = img.width
            height = img.height
            that.upload(file).then(res => {
              res.width = width
              res.height = height
              resultarray.push(res)
              let progressdata = {
                finshnum: resultarray.length,
                totalnum: postFiles.length,
              }
              that.$emit('uploadprogress', progressdata)
              if (resultarray.length === postFiles.length) {
                that.$emit('uploadSuccess', resultarray)
              }
            })
          } else {
            img.onload = function () {
              width = img.width
              height = img.height
              that.upload(file).then(res => {
                res.width = width
                res.height = height
                resultarray.push(res)
                let progressdata = {
                  finshnum: resultarray.length,
                  totalnum: postFiles.length,
                }
                that.$emit('uploadprogress', progressdata)
                if (resultarray.length === postFiles.length) {
                  that.$emit('uploadSuccess', resultarray)
                }
              })
            }
          }
        }
        // this.upload(file).then(res => {
        //   resultarray.push(res)
        //   let progressdata = {
        //     finshnum: resultarray.length,
        //     totalnum: postFiles.length
        //   }
        //   this.$emit('uploadprogress', progressdata)
        //   if (resultarray.length === postFiles.length) {
        //     this.$emit('uploadSuccess', resultarray)
        //   }
        //
        // })
      })
    },
    getUploadPath () {
      let path = 'goodsmanual/' + this.picurl
      if (!isOnLine) {
        path = 'image/goodsmanual/' + this.picurl
      }
      if (!this.hasPathProName) {
        path = this.picurl
        if (!isOnLine) {
          path = 'image/' + this.picurl
        }
      }
      return path
    },
    upload (file) {
      let uuid = uuidv1()
      if (this.accept === 'video/*') { // 上传视频
        return OssUpload.multipartUpload(this.picurl + uuid + '-' + file.name, file).then(r1 => {
          return {
            'name': file.name,
            'url': 'http://image.test.laodao.so/' + r1.url,
            'size': r1.size,
            'rt': r1.rt
          }
        }, () => {
          return {
            'name': file.name,
            'url': 'error_url'
          }
        })
      } else {
        let uploadPath = this.getUploadPath()
        let name = this.getFileSuffix(file.name)
        return OssUpload.put(uploadPath + uuid + name, file).then(r1 => {
          let region = isOnLine ? 'service-center-image.oss-cn-shanghai.aliyuncs.com' : 'service-center.oss-cn-qingdao.aliyuncs.com'
          let domain = isOnLine ? 'image.laodao.so' : 'image.test.laodao.so'
          return {
            'oldname': file.name,
            'name': r1.name,
            'url': r1.url.replace(region, domain)
          }
        }, () => {
          return {
            'oldname': file.name,
            'name': file.name,
            'url': 'error_url'
          }
        })
      }
    },
    getFileSuffix (name) {
      let resultstr = ''
      let index = name.lastIndexOf('.')
      if (index > 0) {
        resultstr = name.substring(index)
      }
      return resultstr
    },
    onDrop (e) {
      if (this.candrag) {
        this.dragOver = false
        if (this.itemDisabled) return
        this.uploadFiles(e.dataTransfer.files)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .input-style {
    display: none;
  }
</style>
